import React, { useEffect, useImperativeHandle } from 'react'

import { IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'

import useSession from '../../session/useSession'
import LoaderView from './View'

import style from './style.module.scss'

const LoaderAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>((_props, ref) => {
    const session = useSession()
    useEffect(() => {
      session.setWidgetWidth(null)
      session.enableNavigation(false)
      session.currentTarget = null
    }, [session])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(
      ref,
      () => {
        return {
          tryNext() {
            return false
          },
          tryPrev() {
            return false
          },
          showValidation() {
            //
          },
          get submitResponse() {
            const submitResponse: IActionSubmitResponse[] = []
            return submitResponse
          },
          get currentQuestionModel(): null {
            return null
          }
        }
      },
      []
    )

    return (
      <div className={style.action}>
        <LoaderView />
      </div>
    )
  }),
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

LoaderAction.displayName = 'LoaderAction'

export default LoaderAction
